import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateUserActive } from '../api/users';
import { Queries } from '../types/queries';
import { UpdateUserActiveRequest } from '../types/users';

interface UpdateUserActiveVariables {
  userId: number;
  request: UpdateUserActiveRequest;
}

/** Updates a user's active status and refreshes the user directory after success. */
const useUpdateUserActive = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, request }: UpdateUserActiveVariables) => updateUserActive(userId, request),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [Queries.UserList] }),
  });
};

export default useUpdateUserActive;
